import { toPriceCurrency } from '@/utils/filters'

export default {
  id: 'po-wo-hist',
  isAutoLoad: false,
  sortable: {
    field: 'year',
    order: 'desc'
  },
  store: {
    get: {
      url: 'Panels/GetAllPanelSupplierPO',
      selected: 'partSN,conditionTitle,baxpo,supplierCompanyName,qty,price,currencyTitle,DateTime(entryDate).year as year',
      filters: 'chosen == true'
    }
  },
  header: {
    title: {
      isVisible: false
    },
    controls: {
      isRefresh: false,
      export: {
        isVisible: false
      },
      addNew: {
        isVisible: false
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-SN")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("condition")}',
      field: 'conditionTitle'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('baxpo')}",
      field: 'baxpo'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('supplier')}",
      field: 'supplierCompanyName'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('qty')}",
      field: 'qty'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('price')}",
      field: 'qty',
      template: (data) => toPriceCurrency(data.price, data.currencyTitle)
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('year')}",
      field: 'year',
      sortable: {
        custom: {
          desc: 'entryDate desc',
          asc: 'entryDate asc'
        }
      }
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: '( partSN.contains("${data.value}") || baxpo.contains("${data.value}") || supplierCompanyName.StartsWith("${data.value}") )',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('search')}"
        }
      },
      {
        type: 'selectautocomplete',
        field: 'supplierCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('supplier-company')}",
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'name.StartsWith("${data.search}")',
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'select',
        field: 'conditionID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('condition')}",
        options: {
          dataSource: 'Conditions/GetAllDynamic?select=id,title&orderBy=title asc',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      }
    ]
  }
}
